<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <div class="panel-title">
                <a data-parent="#accordion" data-toggle="collapse" :href="'#subscriptionDetail' + lps.id" :class="{collapsed: isTerminated}">
                    <h2 class="title">{{ lps.program.display_name }}</h2>
                    <p>Statut : <span>{{ lps.decoded_status }}</span></p>
                    <p>Souscrit le : {{ formatDateHour(lps.created_at) }}</p>
                    <p v-if="lps.terminated_at">Arreté le : {{ formatDateHour(lps.terminated_at) }}</p>
                    <p>
                        <span class="label">{{ lps.points_count > 1 ? lps.points_count + ' points' : lps.points_count + ' point'}}</span>
                        <span class="label label-success">{{ enabledPromoCodesInLps(lps) > 1 ? enabledPromoCodesInLps(lps) + ' codes promo' : enabledPromoCodesInLps(lps) + ' code promo'}}</span>
                    </p>
                </a>
            </div>
            <div v-if="isUserRolesAuthorized" class="buttons__wrapper">
                <div v-if="isActive" class="btn btn-xs btn-info" data-toggle="modal" :data-target="'#update-modal-' + lps.id">Mettre à jour le solde de points</div>
                <div v-if="isDisabled  && !isTerminated" @click="enableLoyaltyProgramSubscription($store.state.customer.id ,lps.id)" class="btn btn-xs btn-success">Réactiver l'adhésion</div>
                <div v-if="!isDisabled && !isTerminated" @click="disableLoyaltyProgramSubscription($store.state.customer.id ,lps.id)" class="btn btn-xs btn-warning">Désactiver l'adhésion</div>
                <div v-if="!isTerminated" class="btn btn-xs btn-danger" data-toggle="modal" :data-target="'#terminate-modal-' + lps.id">Résilier l'adhésion</div>
            </div>
        </div>
        <div class="panel-collapse collapse" :class="{in: !isTerminated}" :id="'subscriptionDetail' + lps.id" :style=detailStyle>
            <div class="panel-body">
                <promo-codes v-if="lps.promo_codes.length" :promoCodes="lps.promo_codes"></promo-codes>
                <activity-log v-if="lps.activity_log.length" :activities="lps.activity_log" :lpsId="lps.id"></activity-log>
            </div>
        </div>

        <!-- MODAL DE RESILIATION -->
        <div v-if="isUserRolesAuthorized" class="modal fade" :id="'terminate-modal-' + lps.id" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
            <div class="modal-dialog ">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="text-left p-b-5"><span class="semi-bold">Résilier l'adhésion</span></h5>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <p>Êtes-vous certain de vouloir résilier l'adhésion, <span class="bold">cette action est irréversible</span> ?</p>
                                <p>Pour information, les codes promo resteront utilisables jusqu'à expiration.</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="btn btn-xs" data-dismiss="modal">Annuler</div>
                        <div @click="terminateLoyaltyProgramSubscription($store.state.customer.id ,lps.id)" class="btn btn-xs btn-danger" data-dismiss="modal">Résilier l'adhésion</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL DE MISE A JOUR DU SOLDE DE POINTS -->
        <div v-if="isUserRolesAuthorized" class="modal fade" :id="'update-modal-' + lps.id" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="text-left p-b-5"><span class="semi-bold">Modifier le solde de points</span></h3>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <h5 class="semi-bold text-success">Simulation</h5>
                                <form class="row" role="form">
                                    <div class="col-md-3 form-group">
                                        <label for="actual-points-count">Solde de points actuel</label>
                                        <input type="number" min="0" step="1" class="form-control" id="actual-points-count" :value="lps.points_count" disabled>
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label for="points-count">Nouveau solde de points</label>
                                        <input v-model="newPointsCount" type="number" min="0" step="1" class="form-control" id="points-count">
                                    </div>
                                </form>
                                <div>
                                    <p class="alert alert-warning">Veuillez procéder à la simulation avant de pouvoir confirmer la mise à jour du solde de points.</p>
                                    <div @click="updateLoyaltyProgramSubscription($store.state.customer.id ,lps.id, newPointsCount, 0, pointsCountComment)" class="btn btn-xs btn-success">Simuler</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="pointsUpdateSimulation" class="row m-t-20">
                            <div class="col-md-12">
                                <div class="alert alert-success">
                                    <h5 class="semi-bold text-success">Résultats</h5>
                                    <p>Cette modification du solde de points engendrerait :</p>
                                    <ul class="m-t-10 p-b-15">
                                        <li v-if="pointsUpdateSimulation.promo_codes_generation">- La génération de {{ pointsUpdateSimulation.promo_codes_count }} codes promo.</li>
                                        <li>- Un nouveau solde de {{ pointsUpdateSimulation.new_points_count }} {{ pointsUpdateSimulation.new_points_count > 1 ? 'points' : 'point' }}.</li>
                                    </ul>
                                    <p>Vous pouvez également ajouter un commentaire au sujet de cette modification manuelle du solde :</p>
                                    <div class="form-group m-t-10">
                                        <textarea v-model="pointsCountComment" name="points-count-comment" id="points-count-comment" cols="100" rows="6"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div @click="resetSimulation" class="btn btn-xs" data-dismiss="modal">Annuler</div>
                        <div v-if="pointsUpdateSimulation" @click="updateLoyaltyProgramSubscription($store.state.customer.id ,lps.id, newPointsCount, 1, pointsCountComment)" class="btn btn-xs btn-success" data-dismiss="modal">Valider cette simulation</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapActions, mapState, mapMutations } from 'vuex'
import { LOYALTY_PROGRAM_POINTS_COUNT_SIMULATION_RESET } from 'store/mutation-types'
import dateFormatting from 'mixins/dateFormatting'
import user from 'mixins/user'

import PromoCodes from './PromoCodes'
import ActivityLog from './ActivityLog'

export default {
    name: "SubscriptionItem",

    data () {
        return {
            newPointsCount: 0,
            pointsCountComment: ''
        }
    },

    components: {
        PromoCodes,
        ActivityLog
    },

    props: [
        'lps',
        'parentId'
    ],

    mixins: [
        dateFormatting,
        user
    ],

    computed: {
        ...mapState('lps', ['pointsUpdateSimulation']),

        isActive () {
            return 'active' === this.lps.status
        },

        isTerminated () {
            return 'terminated' === this.lps.status
        },

        isDisabled () {
            return 'disabled' === this.lps.status
        },

        detailStyle () {
            return this.isTerminated ? { height: 0 } : {}
        }
    },

    methods: {
        ...mapActions('lps', [
            'terminateCustomerLoyaltyProgramSubscription',
            'disableCustomerLoyaltyProgramSubscription',
            'enableCustomerLoyaltyProgramSubscription',
            'updateCustomerLoyaltyProgramSubscription',
        ]),

        ...mapMutations('lps', {
            resetSimulation: LOYALTY_PROGRAM_POINTS_COUNT_SIMULATION_RESET
        }),

        enabledPromoCodesInLps (lps) {
            const enabledPromoCodes = _.filter(lps.promo_codes, (promoCodes) => {
                return promoCodes.state === 'available' ? true : false
            })

            return enabledPromoCodes.length
        },

        terminateLoyaltyProgramSubscription (customerId, lpsId) {
            this.terminateCustomerLoyaltyProgramSubscription({ customerId, lpsId })
        },

        disableLoyaltyProgramSubscription (customerId, lpsId) {
            this.disableCustomerLoyaltyProgramSubscription({ customerId, lpsId })
        },

        enableLoyaltyProgramSubscription (customerId, lpsId) {
            this.enableCustomerLoyaltyProgramSubscription({ customerId, lpsId })
        },

        updateLoyaltyProgramSubscription (customerId, lpsId, newPointsCount, pointsCountConfirm, pointsCountComment) {
            this.updateCustomerLoyaltyProgramSubscription({ customerId, lpsId, newPointsCount, pointsCountConfirm, pointsCountComment })
            this.resetSimulation()
        },
    }
}
</script>

<style lang="scss" scoped>
.buttons__wrapper {
    position: absolute;
    right: 0;
    bottom: 15px;
}
</style>




// WEBPACK FOOTER //
// client/components/Customer/LoyaltyProgram/SubscriptionItem.vue